import { render, staticRenderFns } from "./PdfEdition.vue?vue&type=template&id=d27c0e60&scoped=true"
import script from "./PdfEdition.vue?vue&type=script&lang=js"
export * from "./PdfEdition.vue?vue&type=script&lang=js"
import style0 from "./PdfEdition.vue?vue&type=style&index=0&id=d27c0e60&prod&lang=css"
import style1 from "./PdfEdition.vue?vue&type=style&index=1&id=d27c0e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27c0e60",
  null
  
)

export default component.exports